<template>
    <div class="base-login-pwd" :class="{ 'loginpwd-sp': $store.state.screen == 1 }">
        <img class="logo" src="~images/logo_min.png" />
        <div>
            <input class="value" ref="account" type="text" maxlength="11" placeholder="请输入账号/手机号" v-model="account"
                @focus="onfocus('account')" />
            <input class="value" ref="pwd" type="text" maxlength="16" placeholder="请输入登录密码" v-model="pwd"
                @focus="onfocus('pwd')" />
        </div>
        <div class="btn-login" @click="onLogin">立即登录</div>
        <div class="footer">
            <div class="item" @click="onPhone">手机登录</div>
            <div class="item" @click="$router.push('/base-register')">注册账号</div>
            <div class="item" @click="$router.push('/base-forget-pwd')">忘记密码</div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
import TheTips from '@/components/TheTips'
export default {
    components: {
        TheTips
    },
    data() {
        return {
            msg: null,
            account: '',
            pwd: '',

            appid: '',
            appkey: '',
            channel: 1,
            system: '',
            machine_code: '',
        }
    },
    methods: {
        onfocus(ref) {
            let that = this
            let refs = that.$refs
            if (that.config.system == 1) {
                for (let key in refs) {
                    setTimeout(() => {
                        that.$refs[ref].scrollIntoView({ block: 'end', behavior: 'smooth' })
                    }, 100)
                }
            }
        },
        // 账号密码登录
        onLogin() {
            if (!this.account.replace(/\s*/g, "")) {
                this.msg = '请输入账号'
                setTimeout(() => {
                    this.msg = null
                }, 2000)
                return
            }
            if (!this.pwd.replace(/\s*/g, "")) {
                this.msg = '请输入密码'
                setTimeout(() => {
                    this.msg = null
                }, 2000)
                return
            }
            let obj = {}
            let reg = /^1[0-9]{10}$/
            if (reg.test(this.account)) {
                obj.mobile = this.account
                obj.type = 2
            } else {
                obj.username = this.account
                obj.type = 1
            }
            let appInfo = JSON.parse(sessionStorage.getItem('appInfo'))
            obj = {
                ...obj,
                password: this.pwd,
                appid: appInfo.appid, //应用ID
                channel: appInfo.channel, //渠道ID
                system: appInfo.system, //系统
                machine_code: appInfo.machine_code //设备号
            }
            obj.sign = this.util.getSign(obj, appInfo.appkey);
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=login', this.$qs.stringify(obj)).then(res => {
                if (res.data.status == 1) {
                    sessionStorage.setItem('userData', JSON.stringify(res.data.data))
                    this.msg = '登录成功'
                    setTimeout(() => {
                        this.msg = null
                        this.$router.push('/base-trumpet-select-v2')
                    }, 1000)
                } else {
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            }).catch(o => {
                this.msg = '请求失败'
                setTimeout(() => {
                    this.msg = null
                }, 2000)
            })

        },
        onPhone() {
            this.$emit('childPhone', 1)
            // if (this.config.system == 1) {
            //     if (this.h5LoginData) {
            //         this.$emit('childPhone', 0)
            //     } else {
            //         this.$emit('childPhone', 1)
            //     }
            // } else {
            //     this.$emit('childPhone', 0)
            // }
        }
    },
    created() {
        
    },
}
</script>

<style lang="scss" scoped>
$color: #FF6C22; // 主体颜色

// 横屏css
.base-login-pwd {
    min-height: 756px;
    overflow: hidden;
    transition: all 0.3s;

    .logo {
        width: 126px;
        height: 126px;
        margin: 45px auto 0;
        display: block;
    }

    .value {
        width: 100%;
        height: 120px;
        color: #fff;
        font-size: 39px;
        border: 0;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.2);
        padding: 0 45px;
        margin-top: 30px;
        outline: none;
    }

    .value:first-child {
        margin-top: 45px;
    }

    input::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    input::-moz-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    input::-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    input::-o-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    .btn-login {
        height: 120px;
        font-size: 39px;
        border-radius: 18px;
        background: $color;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }

    .footer {
        width: 100%;
        padding: 0 50px;
        position: absolute;
        left: 0;
        bottom: 59px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item {
            width: 33%;
            height: 32px;
            color: $color;
            font-size: 33px;
            border-right: 2px solid rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .item:last-child {
            border-right: 0;
        }
    }
}

// 竖屏css
.loginpwd-sp {
    min-height: 1374px;

    .logo {
        width: 229px;
        height: 229px;
        margin: 81px auto 0;
    }

    .value {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        padding: 0 81px;
        margin-top: 54px;
    }

    .value:first-child {
        margin-top: 81px;
    }

    .btn-login {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        margin-top: 54px;
    }

    .footer {
        padding: 0 90px;
        bottom: 107px;

        .item {
            height: 58px;
            font-size: 60px;
            border-right: 3px solid rgba(255, 255, 255, 0.2);
        }
    }
}
</style>